import type { Sequence } from "./sequence";
import type * as t from "./types";

export function getRelativeStepIdx(
    segments: Sequence<t.Segment>,
    globalStepIdx: number,
) {
    let idx = 0;
    let globalIdx = 0;

    for (const seg of segments.iterate()) {
        for (const _ of seg.value.steps.iterate()) {
            if (globalIdx === globalStepIdx) {
                return idx;
            }
            ++idx;
            ++globalIdx;
        }
        idx = 0;
    }

    throw new Error(
        "[sphln-quiz]: Unable to get relative step index from global index",
    );
}

function getDiscountPrizeText(prize: t.DiscountPrize) {
    if (prize.type !== "discount") {
        throw new Error("prize is not a discount");
    }

    let prizeText;
    switch (prize.discount_type) {
        case "percentage":
            prizeText = `${prize.discount_value}% off`;
            break;
        case "fixed":
            prizeText = `$${prize.discount_value.toFixed(2)} off`;
            break;
        default:
            throw new Error(
                `Invalid discount prize type ${prize.discount_type}`,
            );
    }

    return prizeText;
}

function getCustomPizeText(prize: t.CustomPrize) {
    return prize.custom_value;
}

export function getPrizeText(prize: t.SegmentConfig["prize"]) {
    switch (prize.type) {
        case "free_shipping":
            return "free shipping";
        case "discount":
            return getDiscountPrizeText(prize);
        case "custom":
            return getCustomPizeText(prize);
        default:
            throw new Error(`Invalid prize type ${(prize as any)?.type}`);
    }
}

export function capitalizeFirstLetter(str: string) {
    const result = [];

    let isFirstCharInWord = true;
    for (const char of str) {
        let charCpy;
        if (isFirstCharInWord && char !== " ") {
            charCpy = char.toUpperCase();
        } else {
            charCpy = char;
        }

        result.push(charCpy);

        isFirstCharInWord = char === " ";
    }

    return result.join("");
}
